import React, { Component } from 'react';
import Tooltip from '../../components/UI/TooltipIcon/TooptipIcon';
import orderBy from 'lodash/orderBy';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import { isMobile } from '../../utils/deviceInfo';
import { Modal, ModalBody, Button, Dropdown, DropdownToggle, DropdownMenu, Popover, PopoverHeader, PopoverBody, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import 'rc-checkbox/assets/index.css';
import Loading from '../../hoc/Loading/Loading';
import Toggle from "react-toggle";
import axios from '../../axios';
import * as url from '../../utils/url';
import * as actionCreators from '../../modules/actions/index';
import { ListGroup, ListGroupItem } from 'reactstrap';
import avatarIcon from '../../assets/default-avatar.png';
import ShowMore from 'react-show-more';
import If from '../../components/Shared/If';
import FooterBar from '../../components/FooterBar/FooterBar';

class CurrentAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.state = {
     item:null
    }
  }




componentDidMount() {
  if(isMobile){
    this.props.updateNavBar({
      title: "Announcements",
      hasBack: true,
      backButton: '<b>Back</b>',
      showNotification: true,
      className: null,
      isBreadCrumbs: false
    });
  }
    this.getAnnouncement()
}


componentWillReceiveProps(nextProps){
  if(this.props.match.params.id!==nextProps.match.params.id){
    this.getStory(nextProps.match.params.id)
  }
}



  getAnnouncement=()=>{
      // console.log("story---", id)
    axios.get(url.currentAnnouncement).then( ({data})  => {
        let item = data.data && data.data[0]?data.data[0]:null
        console.log(item,'---data---', data.data)

        this.setState({
            item,   
        });
      });
  }
  

  createMarkup = (input) => {
    return { __html: `<div>${input}</div>` };
  }

  
  renderStories = () => {
    let{item}=this.state
    console.log(item)
    if(item){
        return (
            <div>
                 {/* <div
                className="sidebar-menuItem announcementTab currentAnnouncementHeading"
              >
            ANNOUNCEMENTS  
            </div> */}
                <div className="announcementText col-xs-12"  >
                  <span dangerouslySetInnerHTML={this.createMarkup(item.description.replace(/\n/g,"<br />"))}></span>
                  {/* <span className="storyOwner">
                    <span className="storyDate">{moment(item.createdOn).format("MMM DD, YYYY")}</span>
                  </span> */}
                </div>
              </div>
              );
    } else {
      return(
        <div>
           {/* <div
                className="sidebar-menuItem announcementTab currentAnnouncementHeading"
              >
            ANNOUNCEMENTS  
            </div> */}

            <div  className="announcementText col-xs-12" >
              No new announcement available at this time. Please check back later.
            </div>
        </div>
      )
     
    }
  };





  render() {
    return (
      <div className={`posts  ${ isMobile ? 'mt-3':'mt40'} `} onMouseLeave={this.removeReactionHover}>
       {this.renderStories()}
       { isMobile && <FooterBar {...this.props}/> }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
    return {
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
    }
  }

  const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(CurrentAnnouncement, axios)));
